<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box unique-report-card">
           <v-toolbar class="toolbar no-display elevation-1 mb-2" flat dense color="white">
                <v-toolbar-title>
                    <span class="font-weight-bold slate--text">
                        Application Form Enrollment Report
                    </span>
                </v-toolbar-title>
                <v-spacer></v-spacer>

            <v-btn class="ma-2 text-capitalize" tile outlined color="warning" small @click="printReport" v-if="applicationList.length">
                <v-icon left>mdi-printer</v-icon> Print PDF
            </v-btn>
            <v-btn rounded class="text-capitalize" color="success" outlined small @click="downloadExcel" v-if="applicationList.length">
                <v-icon left>mdi-export</v-icon> Export Excel
            </v-btn>
           </v-toolbar>

            <v-row justify="center" dense class="no-display mx-2 pt-4 ml-10">
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error" small class="mr-1">*</v-icon>
                    <v-autocomplete color="indigo" dense rounded required v-model="selected_ay" :items="ay_list"
                        item-text="ay" item-value="id" label="Select Academic Year" outlined
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error" small class="mr-1">*</v-icon>
                    <v-autocomplete color="indigo" dense rounded required v-model="selected_standard"
                        :items="standard_list" item-text="standard" item-value="id" label="Please Select Standard"
                        outlined persistent-hint hint="Please Select Standard" />
                </v-col>

                <v-col cols="12" sm="2" md="2">
                    <v-btn class="mt-7 action-fetch-btn" color="indigo" dark small rounded @click="getApplicationFormCount()"
                        :loading="fetch_loader">
                        Fetch
                    </v-btn>
                </v-col>
            </v-row>

            <v-spacer></v-spacer>

            <v-row v-if="reportDataList && reportDataList.length" class="mt-6 mx-2">
                <v-col cols="12">
                    <div class="subtitle-1 font-weight-bold indigo--text mb-3 ml-1">
                      Subject / Group Allocation Report
                    </div>
                    <v-simple-table dense class="custom-designed-table elevation-1">
                        <thead>
                            <tr>
                                <th class="text-left" style="padding-left: 20px;">Subject / Group Name</th>
                                <th class="text-center" style="width: 15%;">Type</th>
                                <th class="text-center" style="width: 20%;">Total Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(report, rIdx) in reportDataList">
                                <tr v-for="(sub, sIdx) in report.linked_subject_list" :key="'row-sub-' + rIdx + '-' + sIdx" class="table-row-hover">
                                    <td class="text-left font-weight-medium wrap-text-col" style="padding-left: 20px !important;">
                                        {{ sub.subject_name || report.subject_head }}
                                    </td>
                                    <td class="text-center">
                                        <v-chip x-small color="indigo" outlined class="font-weight-bold">Subject</v-chip>
                                    </td>
                                    <td class="text-center font-weight-bold indigo--text text-subtitle-2">
                                        <div class="d-flex align-center justify-center">
                                            <span>{{ sub.student_count || 0 }}</span>
                                            <v-btn icon small color="indigo" class="ml-2" @click="viewDetails(sub, 'Subject')">
                                                <v-icon small>mdi-eye</v-icon>
                                            </v-btn>
                                        </div>
                                    </td>
                                </tr>

                                <tr v-for="(grp, gIdx) in report.linked_group_list" :key="'row-grp-' + rIdx + '-' + gIdx" class="table-row-hover">
                                    <td class="text-left font-weight-medium wrap-text-col" style="padding-left: 20px !important;">
                                        {{ grp.group_name || report.subject_head }}
                                    </td>
                                    <td class="text-center">
                                        <v-chip x-small color="purple" outlined class="font-weight-bold">Group</v-chip>
                                    </td>
                                    <td class="text-center font-weight-bold purple--text text-subtitle-2">
                                        <div class="d-flex align-center justify-center">
                                            <span>{{ grp.student_count || 0 }}</span>
                                            <v-btn icon small color="purple" class="ml-2" @click="viewDetails(grp, 'Group')">
                                                <v-icon small>mdi-eye</v-icon>
                                            </v-btn>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" class="my-2"><v-divider></v-divider></v-col>
            </v-row>

             <v-row v-if="summaryStats" justify="start" class="mt-6 mx-4 dense">
                <v-col cols="12" class="d-flex align-center flex-wrap">
                    <v-chip color="indigo" dark small class="font-weight-bold mr-3 mb-2">
                        Total Applications: {{ summaryStats.totalForms }}
                    </v-chip>
                    <v-chip color="success" dark small class="font-weight-bold mr-3 mb-2">
                        Total Paid: {{ summaryStats.paidCount }}
                    </v-chip>
                    <v-chip color="error" dark small class="font-weight-bold mr-3 mb-2">
                        Total Unpaid: {{ summaryStats.unpaidCount }}
                    </v-chip>
                </v-col>
            </v-row>

            <v-row v-if="applicationList && applicationList.length" justify="center" class="mt-2 mx-2 pb-6">
                <v-col cols="12">
                    <div class="subtitle-1 font-weight-bold slate--text mb-3 ml-1">
                        Admission Applications Count
                    </div>
                    <v-simple-table dense class="custom-designed-table elevation-1">
                        <thead>
                            <tr>
                                <th class="text-center text-no-wrap" style="width: 10%;">Sr No.</th>
                                 <th class="text-left text-no-wrap" style="padding-left: 15px;">Registration Number</th>
                                <th class="text-left text-no-wrap" style="padding-left: 20px;">Student Name</th>
                                <th class="text-center text-no-wrap" style="width: 25%;">Fee Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, idx) in applicationList" :key="idx" class="table-row-hover">
                                <td class="text-center sr-num-col">{{ idx + 1 }}</td>
                                <td class="text-left name-text-col" style="padding-left: 15px !important;">
                                    {{ item.prn || '--' }}
                                </td>
                                <td class="text-left name-text-col" style="padding-left: 20px !important;">
                                    {{ item.student_name || 'N/A' }}
                                </td>
                                <td class="text-center">
                                    <v-chip class="font-weight-bold custom-status-chip" size="x-small" small dense 
                                        :color="item.fees_status === 'Paid' ? 'success' : 'error'" outlined>
                                        <v-icon left x-small>
                                            {{ item.fees_status === 'Paid' ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                                        </v-icon>
                                        {{ item.fees_status }}
                                    </v-chip>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-card>

        <v-dialog v-model="studentDetailsDialog" max-width="1000px" scrollable>
            <v-card class="dialog-roster-card">
                <v-card-title class="headline grey lighten-3 d-flex justify-space-between align-center py-3 px-4">
                    <div class="d-flex align-center" style="max-width: 90%;">
                        <div style="width: 100%;">
                            <span class="font-weight-bold text-subtitle-1 slate--text">Enrolled Students</span>
                            <div class="caption font-weight-bold indigo--text dialog-sub-heading-wrap">
                                Subject/Group Name: {{ dialogHeaderTitle }}
                            </div>

                           <v-row justify="space-between">
                             <span class="caption font-weight-bold mt-2 ml-5">
                               Total Count: {{ totalCount }}
                            </span>
                            <span class="caption font-weight-bold mt-2" style="color: green;">
                               Total Paid Count: {{ totalPaid }} 
                            </span>
                             <span class="caption font-weight-bold mt-2" style="color: red;">
                               Total Unpaid Count: {{ totalUnpaid }}
                            </span>
                           </v-row>
                        </div>
                    </div>
                    <v-btn icon small @click="studentDetailsDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                
                <v-card-text class="pa-4 grey lighten-5" style="max-height: 70vh;">
                    <v-simple-table dense class="nested-student-table border elevation-1 student-table" v-if="enrolledStudents && enrolledStudents.length">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 80px;">Sr No.</th>
                                <th class="text-left" style="width: 140px;">PRN Number</th>
                                <th class="text-left">Student Name</th>
                                <!-- <th class="text-center" style="width: 80px;">Roll No</th> -->
                                <th class="text-right" style="width: 110px;">Total Fees</th>
                                <th class="text-right" style="width: 110px;">Paid Amt</th>
                                <th class="text-left" style="padding-left: 20px; width: 200px;">Paid Date</th>
                                <!-- <th class="text-left" style="padding-left: 20px;">Txn ID</th> -->
                                <th class="text-center" style="width: 100px;">Fee Status</th> 
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(stu, stIdx) in enrolledStudents" :key="'modal-stu-'+stIdx" class="bg-white">
                                <td class="text-center grey--text font-weight-medium">{{ stIdx + 1 }}</td>
                                <td class="font-weight-bold indigo--text">{{ stu.learner_prn || '--' }}</td>
                                <td class="font-weight-medium text-no-wrap" >{{ stu.learner_name || 'N/A' }}</td>
                                <!-- <td class="text-center">{{ stu.roll_no }}</td>  -->
                                <td class="text-right font-weight-medium">₹{{ Number(stu.total_fees || 0).toFixed(2) }}</td>
                                <td class="text-right success--text font-weight-medium">₹{{ Number(stu.fees_amount || 0).toFixed(2) }}</td>
                                <td class="text-left grey--text text--darken-2" style="padding-left: 20px !important;">
                                    {{ stu.fees_paid_date || '--' }}
                                </td>
                                <!-- <td class="caption text-truncate font-weight-light" style="padding-left: 20px !important; max-width: 160px;" :title="stu.transaction_id">
                                    {{ stu.transaction_id || '--' }}
                                </td> -->
                                <td class="text-center">
                                    <v-chip x-small dense class="font-weight-bold custom-status-chip" 
                                        :color="(stu.is_fees_paid === 'Yes' || stu.is_fees_paid === 'Paid') ? 'success' : 'error'" outlined>
                                        {{ (stu.is_fees_paid === 'Yes' || stu.is_fees_paid === 'Paid') ? 'Paid' : 'Unpaid' }}
                                    </v-chip>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <div v-else class="text-center py-8 grey--text text--darken-1 subtitle-2 font-italic">
                        <v-icon large color="grey lighten-1" class="d-block mb-2">mdi-account-off-outline</v-icon>
                        No active student allocations found for this Subject/Group.
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-overlay :value="dialogLoader" opacity="0.4" color="slate" style="z-index: 99999;">
             <v-progress-circular indeterminate size="64" color="indigo" width="5"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import "@/assets/css/color.css";

export default {
    data() {
        return {
            snackbar: false,
            snackbar_msg: "",
            color: "",
            fetch_loader: false,
            dialogLoader: false,

            ay_list: [],
            standard_list: [],
            selected_ay: "",
            selected_standard: "",

            applicationList: [],
            reportDataList: [],
            enrolledStudents: [],
            summaryStats: null,
            totalCount:"",
            totalPaid:"",
            totalUnpaid:"",

            display_ay: "",
            display_standard: "",

            // Modal Controls
            studentDetailsDialog: false,
            dialogHeaderTitle: "",
            dialogType: ""
        };
    },

    mounted() {
        this.onload();
    },

    methods: {
        onload() {
            axios
                .post("/QuizScheduling/getAllData")
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.ay_list = res.data.ay_list;
                        this.standard_list = res.data.standard_list;
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong loading basic records...");
                });
        },

        getApplicationFormCount() {
            if (!this.selected_ay || !this.selected_standard) {
                this.showSnackbar("#b71c1c", "Select Academic Year and Standard...");
                return;
            }

            this.fetch_loader = true;
            this.dialogLoader = true;
            this.applicationList = [];
            this.reportDataList = [];
            this.summaryStats = null;

            const payload = {
                ay: this.selected_ay,
                standard: this.selected_standard
            };

            axios
                .post("/admission/getApplicationFormCount", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.applicationList = res.data.applicationList || [];
                        this.reportDataList = res.data.reportDataList || [];
                        this.summaryStats = res.data.stats || { totalForms: 0, paidCount: 0, unpaidCount: 0 };
                        this.display_ay = res.data.ay;
                        this.display_standard = res.data.standard;

                        if(this.applicationList.length <= 0){
                            this.showSnackbar("#b71c1c", "No Data Found");
                        }
                    } else {
                        this.showSnackbar("#b71c1c", res.data.msg || "Failed to retrieve application data.");
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.showSnackbar("#b71c1c", "Something went wrong fetching structural payload.");
                })
                .finally(() => {
                    this.fetch_loader = false;
                    this.dialogLoader = false;
                });
        },

        viewDetails(item, type) {
           this.dialogLoader = true;
           this.dialogType = type;
           this.dialogHeaderTitle = item.subject_name || item.group_name || "";
           this.enrolledStudents = [];

           const payload = {
              id: item.id,
              type: type 
           };

           axios
                .post("/admission/getEnrolledStudents", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.enrolledStudents = res.data.studentList || [];
                        this.totalCount = res.data.totalCount;
                        this.totalPaid = res.data.totalPaidCount;
                        this.totalUnpaid = res.data.totalUnpaidCount;
                        this.studentDetailsDialog = true; 
                    } else {
                        this.showSnackbar("#b71c1c", "Failed to retrieve student records.");
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.showSnackbar("#b71c1c", "An unexpected network error occurred.");
                })
                .finally(() => {
                    this.dialogLoader = false;
                });
        },

        downloadExcel() {
            const allocationData = [];
            let allocIndex = 1;
            
            this.reportDataList.forEach(report => {
                if (report.linked_subject_list) {
                    report.linked_subject_list.forEach(sub => {
                        allocationData.push({
                            "Sr No.": allocIndex++,
                            "Subject / Group Name": sub.subject_name || report.subject_head,
                            "Type": "Subject",
                            "Total Count": sub.student_count || 0
                        });
                    });
                }
                if (report.linked_group_list) {
                    report.linked_group_list.forEach(grp => {
                        allocationData.push({
                            "Sr No.": allocIndex++,
                            "Subject / Group Name": grp.group_name || report.subject_head,
                            "Type": "Group",
                            "Total Count": grp.student_count || 0
                        });
                    });
                }
            });

            const applicationData = this.applicationList.map((item, index) => ({
                "Sr No.": index + 1,
                "Registration Number": item.prn || '--',
                "Student Name": item.student_name || 'N/A',
                "Fee Status": item.fees_status
            }));

            const workbook = XLSX.utils.book_new();

            const wsAlloc = XLSX.utils.json_to_sheet(allocationData);
            XLSX.utils.book_append_sheet(workbook, wsAlloc, "Allocations Report");

            const wsApp = XLSX.utils.json_to_sheet(applicationData);
            XLSX.utils.book_append_sheet(workbook, wsApp, "Applications Count");

            XLSX.writeFile(workbook, "Enrollment_Report.xlsx");
        },

        printReport() {
            let allocationRows = '';
            this.reportDataList.forEach(report => {
                if (report.linked_subject_list) {
                    report.linked_subject_list.forEach(sub => {
                        allocationRows += `
                            <tr>
                                <td style="text-align:left; padding:10px; border-bottom:1px solid #e2e8f0;">${sub.subject_name || report.subject_head}</td>
                                <td style="text-align:center; padding:10px; border-bottom:1px solid #e2e8f0;"><span style="color:#3f51b5; font-weight:bold;">Subject</span></td>
                                <td style="text-align:center; padding:10px; border-bottom:1px solid #e2e8f0; font-weight:bold;">${sub.student_count || 0}</td>
                            </tr>
                        `;
                    });
                }
                if (report.linked_group_list) {
                    report.linked_group_list.forEach(grp => {
                        allocationRows += `
                            <tr>
                                <td style="text-align:left; padding:10px; border-bottom:1px solid #e2e8f0;">${grp.group_name || report.subject_head}</td>
                                <td style="text-align:center; padding:10px; border-bottom:1px solid #e2e8f0;"><span style="color:#9c27b0; font-weight:bold;">Group</span></td>
                                <td style="text-align:center; padding:10px; border-bottom:1px solid #e2e8f0; font-weight:bold;">${grp.student_count || 0}</td>
                            </tr>
                        `;
                    });
                }
            });

            const applicationRows = this.applicationList.map((item, idx) => `
                <tr>
                    <td style="text-align:center; padding:10px; border-bottom:1px solid #e2e8f0; color:#475569;">${idx + 1}</td>
                    <td style="text-align:left; padding:10px; border-bottom:1px solid #e2e8f0; font-family:monospace;">${item.prn || '--'}</td>
                    <td style="text-align:left; padding:10px; border-bottom:1px solid #e2e8f0; font-weight:600;">${item.student_name || 'N/A'}</td>
                    <td style="text-align:center; padding:10px; border-bottom:1px solid #e2e8f0;">
                        <span style="color: ${item.fees_status === 'Paid' ? '#16a34a' : '#dc2626'}; font-weight:bold;">
                            ${item.fees_status}
                        </span>
                    </td>
                </tr>
            `).join('');

            const html = `
                <html>
                <head>
                    <style>
                        body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; padding: 20px; color: #1e293b; }
                        .summary-box { display: flex; justify-content: space-around; margin: 20px 0; padding: 10px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; }
                        .stat-item { text-align: center; font-size: 14px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 10px; margin-bottom: 30px; }
                        th { background-color: #1e293b; color: #ffffff; padding: 12px; font-size: 13px; text-transform: uppercase; }
                        td { font-size: 13px; }
                        h3 { color: #1e293b; margin-top: 25px; margin-bottom: 5px; border-bottom: 2px solid #cbd5e1; padding-bottom: 5px; }
                        
                        /* FORCE NEW PAGE DURING PRINTING */
                        .new-page {
                            page-break-before: always;
                            break-before: page;
                        }
                    </style>
                </head>
                <body>
                    <h2 style="text-align:center; margin-bottom: 5px;">Enrollment Report</h2>
                    <div style="text-align:center; margin-bottom:10px; font-size: 14px;">
                        <b>Academic Year:</b> ${this.display_ay} | <b>Standard:</b> ${this.display_standard}
                    </div>
                    
                    <div class="summary-box">
                        <div class="stat-item"><b>Total Applications:</b> ${this.summaryStats.totalForms || 0}</div>
                        <div class="stat-item" style="color:#16a34a;"><b>Total Paid:</b> ${this.summaryStats.paidCount || 0}</div>
                        <div class="stat-item" style="color:#dc2626;"><b>Total Unpaid:</b> ${this.summaryStats.unpaidCount || 0}</div>
                    </div>

                    <h3>Subject / Group Allocation Report</h3>
                    <table>
                        <thead>
                            <tr>
                                <th style="width: 60%; text-align:left;">Subject / Group Name</th>
                                <th style="width: 20%; text-align:center;">Type</th>
                                <th style="width: 20%; text-align:center;">Total Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${allocationRows || '<tr><td colspan="3" style="text-align:center; padding:10px;">No Allocations Records Found</td></tr>'}
                        </tbody>
                    </table>

                    <h3 class="new-page">Admission Applications Count</h3>
                    <table>
                        <thead>
                            <tr>
                                <th style="width: 10%; text-align:center;">S.No</th>
                                <th style="width: 25%; text-align:left;">Registration Number</th>
                                <th style="width: 45%; text-align:left;">Student Name</th>
                                <th style="width: 20%; text-align:center;">Fee Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${applicationRows || '<tr><td colspan="4" style="text-align:center; padding:10px;">No Applications Found</td></tr>'}
                        </tbody>
                    </table>
                </body>
                </html>
            `;
            
            const win = window.open('', '_blank');
            win.document.write(html);
            win.document.close();
            win.focus();
            setTimeout(() => {
                win.print();
                win.close();
            }, 250);
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        }
    }
};
</script>

<style scoped>
.unique-report-card {
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
    background-color: #fafbfc !important;
}

.custom-designed-table {
    width: 100% !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
    border: 1px solid #cbd5e1 !important;
    border-radius: 6px !important;
    overflow: hidden;
    background-color: #ffffff !important;
}

.custom-designed-table>>>table {
    width: 100% !important;
    table-layout: fixed !important;
}

.custom-designed-table>>>thead tr th {
    background-color: #1e293b !important;
    color: #ffffff !important;
    font-size: 9.5pt !important;
    font-weight: 600 !important;
    height: 44px !important;
    letter-spacing: 0.3px;
    border: none !important;
}

.custom-designed-table>>>tbody tr {
    height: 38px !important;
    transition: background-color 0.15s ease;
}

.custom-designed-table>>>tbody tr:nth-of-type(even) {
    background-color: #f8fafc !important;
}

.custom-designed-table>>>tbody tr td {
    font-size: 9.5pt !important;
    border-bottom: 1px solid #e2e8f0 !important;
    color: #334155 !important;
    padding: 6px 12px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.custom-designed-table>>>tbody tr:last-child td {
    border-bottom: none !important;
}

.wrap-text-col {
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    line-height: 1.4 !important;
}

.table-row-hover:hover {
    background-color: #f0f4f8 !important;
}

.sr-num-col {
    color: #94a3b8 !important;
    font-weight: 500;
}

.name-text-col {
    font-weight: 600 !important;
    color: #0f172a !important;
}

.custom-status-chip {
    font-size: 8pt !important;
    height: 22px !important;
}

/* Modal Layout Styles */
.dialog-roster-card {
    border-radius: 8px !important;
    overflow: hidden;
}

.dialog-sub-heading-wrap {
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
    line-height: 1.3 !important;
}

.nested-student-table {
    border-radius: 4px !important;
    overflow: hidden;
    border: 1px solid #cbd5e1 !important;
    background-color: #ffffff !important;
}

.nested-student-table>>>table {
    width: 100% !important;
}

.nested-student-table>>>thead tr th {
    background-color: #475569 !important;
    color: #ffffff !important;
    font-size: 14px !important;    
    font-weight: 700 !important;
    height: 50px !important;
}

.nested-student-table>>>tbody tr {
    height: 34px !important;
}

.nested-student-table>>>tbody tr:nth-of-type(even) {
    background-color: #f8fafc !important;
}

.nested-student-table>>>tbody tr td {
    font-size: 14px !important;     
    font-weight: 500 !important;
    border-bottom: 1px solid #e2e8f0 !important;
    color: #334155 !important;
    padding: 10px 12px !important;
}

</style>